import { useContext } from 'react';
import { CurrentUserContext } from '../contexts/CurrentUserContext';
import { EOrganizationSelectionStatus, OrganizationContext } from '../contexts/OrganizationContext';
import { AuthenticatedRoutes } from '../routers/AuthenticatedRoutes';
import { adminRoles } from '../const/roles';

export const useHomeUrl = () => {
  const { selectionStatus } = useContext(OrganizationContext);

  const { userInfo } = useContext(CurrentUserContext);

  switch (selectionStatus) {
    case EOrganizationSelectionStatus.NotSelected:
      return AuthenticatedRoutes.ChooseOrganization();

    case EOrganizationSelectionStatus.Selected:
    case EOrganizationSelectionStatus.Default:
      return AuthenticatedRoutes.CurrentOrganizationOverview();

    case EOrganizationSelectionStatus.Skipped: {
      if (!userInfo) {
        return '/';
      }
      const roleIds = userInfo.roles.map((role) => role.id);
      const mappedRoles = roleIds.map((roleId) => adminRoles.find((role) => role.id === roleId));

      if (mappedRoles.filter((role) => !!role)) {
        return AuthenticatedRoutes.GlobalOverview();
      }
      if ((userInfo.organizations?.length ?? 0) === 0) {
        return AuthenticatedRoutes.NoOrganization();
      } else {
        return '/';
      }
    }

    default:
      return '/';
  }
};
